import { Commands } from '../../../UI/Command';
var StylesChangedCommand = (function () {
    function StylesChangedCommand(data) {
        this.gridId = data.Arguments[0].GridId;
    }
    Object.defineProperty(StylesChangedCommand.prototype, "name", {
        get: function () {
            return Commands.StylesChangedCommand;
        },
        enumerable: false,
        configurable: true
    });
    return StylesChangedCommand;
}());
export { StylesChangedCommand };
